import {GET_CUSTOMER_COMPLAINTS_REQUESTED, UPDATE_COMPLAINT_REQUESTED} from 'resources/actionTypes';

export function getCustomerComplaints(data) {
    return {
      type: GET_CUSTOMER_COMPLAINTS_REQUESTED,
      payload: data,
    };
  }

  export function getUpdateComplaintApi(data) {
    return {
      type: UPDATE_COMPLAINT_REQUESTED,
      payload: data, // Pass the complaint ID and update payload (status, comment)
    };
  }